import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './authentication-layout.component.html',
    styleUrls: ['./authentication-layout.component.scss'],
})
export class AuthenticationLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit(): void { }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/common/authentication-layout/authentication-layout.component.ts